/* =================== TABS =================== */
jQuery(document).ready(function ($) {
  $(".tabs-abas li").on("click", function () {
    var tabId = $(this).data("tab");

    $(".tabs-abas li").removeClass("active");
    $(".tab-content").removeClass("active");

    $(".home-funcao-left").removeClass("active");

    $("#" + tabId).addClass("active");
    $(this).addClass("active");

    $(".home-funcao-left.active")
      .find(".home-fun-video")
      .trigger("pause")
      .trigger("play");

    //console.log(tabId);

    setTimeout(() => {
      $("#" + tabId)
        .find(".home-funcao-left")
        .addClass("active");
      $(".home-funcao-left.active").find(".home-fun-video").trigger("play");

      $(".home-funcao-left:not(.active)")
        .find(".home-fun-video")
        .trigger("pause");
    }, 100);
  });
});
